const types = {
  IS_PIN_VALID: "IS_PIN_VALID",
  GET_PROPERTY_ID: "GET_PROPERTY_ID",
  GET_QUICK_PERMIT_SETUP_DETAIL: "GET_QUICK_PERMIT_SETUP_DETAIL",
  GET_PERMIT_DETAIL: "GET_PERMIT_DETAIL",
  GET_QUICK_PEMIT_CREATE_DATA: "GET_QUICK_PEMIT_CREATE_DATA",
  RESET_QUICK_PERMIT_DATA: "RESET_QUICK_PERMIT_DATA",
};
export default types;
